import React from 'react'
import Switch from "react-switch";

export const Switcher = ({check=false, setCheck, w,h,d}) => {
    const [checked, setChecked] = React.useState(check)

    const handleChange = () => {
        setChecked(!checked)  
    }
    React.useEffect(()=>{
        setChecked(!checked)
    },[check])


    return <div
            className={checked?`originalColor`:``}
        >
        <Switch
        onChange={handleChange}
        checked={checked}
        uncheckedIcon={false}
        checkedIcon={false}
        onColor="#3e82f7"
        offColor="#bfbfbf"
        width={w||50}
        height={h||25}
        handleDiameter={d||20}
    /></div>
   
}
